import { createSelector } from 'reselect'

const desmosSelector = state => state.desmos

const creationToolContainerSelector = createSelector(
	[ desmosSelector ],
	desmosState => {
		let previewGraph
		const graphsCategory = desmosState.categories.find(category => category.categoryName === desmosState.category)
		if (desmosState.previewGraph) {
			const category = graphsCategory ? graphsCategory : ''

			if (category) {
				previewGraph = category.graphs.find(graph => graph.graphId === desmosState.previewGraph)
			} else {
				previewGraph = {
					graphId: desmosState.previewGraph,
					title: '',
					url: '',
				}
			}
		}

		let graphs = []
		if (graphsCategory) {
			graphs = graphsCategory.graphs.map(graph => ({
				...graph,
				contentId: graph.graphId,
			}))
		}

		const categoryTabs = desmosState.categories.map(category => ({
			tabId: category.categoryName,
			tabName: `Desmos_Category_${category.categoryName}`,
		}))

		return {
			...desmosState,
			graphs,
			categoryTabs,
			selectedCategory: desmosState.category,
			previewGraph: previewGraph ? previewGraph : null,
		}
	}
)

export default creationToolContainerSelector
